import { BaseBody } from '../BaseBody.js';
import { CssVars } from '../../../util/CssVars.js';

const glyphname = 'modePlagalFirst';
const args = {};

export class ModePlagalFirst extends BaseBody {
  constructor() {
    super(glyphname, args);
  }
}
